// @ts-check

/**
 * Chapter rail: a persistent right-edge progress element for the exhibition
 * runway. Shows I / II / III with the active chapter name, and jumps to a
 * hall on click. This is the "thread" that keeps the three halls connected.
 */
export class ChapterRail {
  /**
   * @param {HTMLElement} container
   * @param {Object[]} chapters - [{ id, numeral, title }]
   * @param {Object} [options={}]
   * @param {(hallId: string) => void} [options.onJump]
   */
  constructor(container, chapters, options = {}) {
    this.container = container;
    this.chapters = chapters;
    this.onJump = options.onJump ?? (() => {});
    this.activeId = null;
    this.items = new Map();

    this.render();
  }

  render() {
    this.container.innerHTML = '';

    this.chapters.forEach((chapter) => {
      const item = document.createElement('button');
      item.className = 'rail-item';
      item.type = 'button';
      item.setAttribute('aria-label', `跳转到 ${chapter.title} 展厅`);
      item.innerHTML = `
        <span class="rail-numeral">${chapter.numeral}</span>
        <span class="rail-bar" aria-hidden="true"></span>
        <span class="rail-name">${chapter.title}</span>
      `;
      item.addEventListener('click', () => this.onJump(chapter.id));
      this.container.appendChild(item);
      this.items.set(chapter.id, item);
    });
  }

  /**
   * @param {string|null} hallId
   */
  setActive(hallId) {
    if (hallId === this.activeId) return;
    this.activeId = hallId;
    this.items.forEach((item, id) => {
      item.classList.toggle('is-active', id === hallId);
    });
  }

  /** @param {boolean} visible */
  setVisible(visible) {
    this.container.classList.toggle('is-visible', visible);
  }
}
